import { ReviewPeriod } from "src/app/models/review-period.model";
import { ReviewPeriodStatusEnum } from "../enums/review-period-status.enum";
import { ReviewTypeEnum } from "../enums/review-type.enum";
import { SettingsState } from "../store/settings.state";
import { State } from "../models/state.model";
import { DateHelper } from "../shared/helpers";
import { Temporal } from "@js-temporal/polyfill";

export abstract class ReviewPeriodHelper {
    
    public static getCurrentReviewPeriod(list: ReviewPeriod[]): ReviewPeriod {
        let today = Temporal.Now.plainDateISO();
        
        let result = list.filter(x => {
            return DateHelper.isPlainDateBetween(today, x.startDate, x.endDate);
        });

        return result.length > 0 ? result[0] : list[0];
    }

    public static isBlockEditable(settingState: SettingsState, state: State): boolean {
      const item = settingState.reviewPeriod.value;
      const items = settingState.reviewPeriodList.value;
  
      if (!state.isSuperAdmin && !state.isAdmin) return false;
  
      if (!item || items.length === 0) return false;
      
      if (item.status == ReviewPeriodStatusEnum.Closed)
        return false;
      
      return true;
    }

  public static getDateRange(rp: ReviewPeriod): string {
    if (!rp || !rp.startDate || !rp.endDate) return '';
    return `${DateHelper.formatPlainDateShort(rp.startDate)} - ${DateHelper.formatPlainDateShort(rp.endDate)}`;
  }

  public static getListTER(allReviews: ReviewPeriod[]): ReviewPeriod[] {
      return allReviews.filter(x => x.reviewType == ReviewTypeEnum.TER);
  }

  public static getLastTER(allReviews: ReviewPeriod[]): ReviewPeriod {
    const items = ReviewPeriodHelper.getListTER(allReviews);
    return items[items.length - 1];
  }

  public static isSziluett(reviewType: ReviewTypeEnum): boolean {
    return reviewType == ReviewTypeEnum.PersonalityTest;
  }

  public static isRpSziluett(rp: ReviewPeriod): boolean {
    return this.isSziluett(rp.reviewType);
  }

  public static isMilio(reviewType: ReviewTypeEnum): boolean {
      return reviewType == ReviewTypeEnum.MilioStressMap || reviewType == ReviewTypeEnum.MilioTeamDysfunction;
  }

  public static isPanoramaAuraGoals(reviewType: ReviewTypeEnum): boolean {
      return reviewType == ReviewTypeEnum.TER;
  }

  public static isRpOpen(rp: ReviewPeriod): boolean {
    return rp?.status == ReviewPeriodStatusEnum.Open;
  }

  public static isRpNew(rp: ReviewPeriod): boolean {
    return rp?.status == ReviewPeriodStatusEnum.New;
  }

  public static isRpClosed(rp: ReviewPeriod): boolean {
    return rp?.status == ReviewPeriodStatusEnum.Closed;
  }

  public static isOnlyGoals(rp: ReviewPeriod): boolean {
    return rp?.reviewType == ReviewTypeEnum.TER && (rp.isGoalsEnabled && !rp.isPositionBasedAssessment && !rp.isSpecialQuestionSetBasedAssessment);
  }

  public static isEditableByDate(rp: ReviewPeriod): boolean {
    if (ReviewPeriodHelper.isRpOpen(rp))
        return DateHelper.isPlainTodayBetween(rp.goalsStartDate, rp.goalsEndDate);
    else 
        return ReviewPeriodHelper.isRpClosed(rp);
  }

}